import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { getAttribute, getFilter } from "./get";

const sourceMap = {
  top_new: "吸顶",
  discovery_material_top: "横幅",
  discovery_waterfall_fixed_1: "固定1",
  discovery_waterfall_fixed_2: "固定2",
  discovery_waterfall_random_1: "随机1",
  search_waterfall_fixed_1: "固定1",
  search_waterfall_fixed_2: "固定2",
  search_waterfall_random_1: "随机1",
};

function getTrackData(target, type) {
  const page = getPage();
  const filter = getFilter(page.page_nm);
  const trackData = {
    ...(type === "expose"
      ? { event_id: 35001, event_name: "resource_loc_expose" }
      : { event_id: 35002, event_name: "resource_loc_click" }),
    ...page,
    resource_type: getAttribute(target, "data-resource-type") || "",
    resource_id: getAttribute(target, "data-resource-id") || "0",
    resource_title: getAttribute(target, "data-resource-title"),
    subject_name: getAttribute(target, "data-subject-name") || undefined,
    plan_id: getAttribute(target, "data-plan-id") || undefined,
    plan_name: getAttribute(target, "data-plan-name") || undefined,
  };

  const apply_client = getAttribute(target, "data-apply-client");
  if (apply_client) {
    trackData.apply_client = apply_client;
  }

  const { page_nm, sub_page_nm } = page;

  var source = getAttribute(target, "data-content-source");

  if (source) {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.resource_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }_${sourceMap[source] || source}`;
    } else {
      trackData.resource_source = `${page_nm}_${sub_page_nm || ""}_${
        sourceMap[source] || source
      }`;
    }
  } else {
    if (filter.filter_one && filter.filter_one.length > 0) {
      trackData.resource_source = `${page_nm}_${sub_page_nm || ""}_${
        filter.filter_one[0]
      }`;
    } else {
      trackData.resource_source = `${page_nm}_${sub_page_nm || ""}`;
    }
  }

  if (
    page_nm === "搜索结果页" ||
    page_nm === "专题页" ||
    page_nm === "主题页"
  ) {
    getSearchData(trackData);
  }

  const item_location = getAttribute(target, "data-item-location");
  if (item_location) {
    trackData.item_location = item_location;
  }

  const resource_function = getAttribute(target, "data-resource-func");
  if (resource_function) {
    trackData.resource_function = resource_function;
  }

  const resource_location = getAttribute(target, "data-resource-location");
  if (resource_location) {
    trackData.resource_location = resource_location;
  }

  const module_name = getAttribute(target, "data-module-name");
  if (module_name) {
    trackData.module_name = module_name;
  }

  const search_result_number = getAttribute(
    target,
    "data-search-result-number"
  );
  if (search_result_number) {
    trackData.search_result_number = search_result_number;
  }

  const module_location = getAttribute(target, "data-module-location");
  if (module_location) {
    trackData.module_location = module_location;
  }

  const page_name = getAttribute(target, "data-page-name");
  if (page_name) {
    trackData.page_name = page_name;
  }

  const sub_page_nm_attr = getAttribute(target, "data-sub-page-nm");
  if (sub_page_nm_attr) {
    trackData.sub_page_nm = sub_page_nm_attr;
  }

  const search_word = getAttribute(target, "data-search-word");
  if (search_word) {
    trackData.search_word = search_word;
  }

  if (page_nm === "采集详情页" && trackData.search_word) {
    getSearchData(trackData);
  }

  // 分发标识
  const word_dist_code = getAttribute(target, "data-word-dist-code");
  if (word_dist_code) {
    trackData.word_dist_code = word_dist_code;
  }

  // 来源 file_ids
  const source_file_ids = getAttribute(target, "data-source-file-ids");
  if (source_file_ids) {
    trackData.source_file_ids = source_file_ids;
  }

  return trackData;
}

export function resource_loc_expose(target) {
  const trackData = getTrackData(target, "expose");
  reporter(trackData);
}

export function resource_loc_click(target) {
  const trackData = getTrackData(target, "click");

  const click_type = getAttribute(target, "data-click-type");
  if (click_type) {
    trackData.click_type = click_type;
  }

  reporter(trackData);
}
